export enum CustomHeaders {
  TRANSFORM_REQUEST = 'TRF-REQ',
  TRANSFORM_RESPONSE = 'TRF-RES',
}
